export default __webpack_public_path__ + "static/media/ai_creator_greeting_image.ef9b2458.png";